import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.css'],
})
export class StripeComponent {
  url: string = 'stripe';
  data: Array<any> = [];
  charges: Array<any> = [];
  payments: Array<any> = [];
  balances: Array<any> = [];
  customers: Array<any> = [];
  payouts: Array<any> = [];
  disputes: Array<any> = [];
  refunds: Array<any> = [];
  step = 1;
  currency = '';
  balance = 0;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers/finance/plaid',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];
  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('response', response);

      if (response.rst) {
        this.data = response.data;
        this.charges = response.data.charges;
        this.payments = response.data.payments;
        this.balances = response.data.balance;
        this.customers = response.data.customers;
        this.currency = response.data.balance.available[0].currency;
        this.balance = response.data.balance.available[0].amount;
        this.payouts = response.data.payouts;
        this.disputes = response.data.disputes;
        this.refunds = response.data.refunds;
      }
    });
  }

  changeStep(step: number) {
    this.step = step;
  }

  getCustomerName(id: string): string {
    const cust = this.customers.find((p) => p.id === id);
    console.log('cust', cust);
    return cust ? cust.name + '(' + cust.email + ')' : 'Unknown';
  }
}
